var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98678 0.00214619C7.98678 0.00214619 12.6943 -0.208259 15.1901 4.50456H7.58622C7.58622 4.50456 6.15122 4.4585 4.92541 6.19241C4.57328 6.92017 4.19478 7.66985 4.61953 9.14729C4.00766 8.11482 1.37109 3.5423 1.37109 3.5423C1.37109 3.5423 3.23078 0.18846 7.98672 0.00214619H7.98678Z",
    fill: "#EF3F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9458 11.9663C14.9458 11.9663 12.7735 16.1333 7.42993 15.9272C8.09019 14.7895 11.233 9.36868 11.233 9.36868C11.233 9.36868 11.9923 8.15431 11.0965 6.22973C10.6409 5.56116 10.1765 4.86191 8.68 4.48922C9.88389 4.47832 15.1769 4.48922 15.1769 4.48922C15.1769 4.48922 17.1598 7.77073 14.9458 11.9663Z",
    fill: "#FCD900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06055 11.999C1.06055 11.999 -1.47701 8.04242 1.37524 3.53564C2.0333 4.67333 5.17605 10.0942 5.17605 10.0942C5.17605 10.0942 5.85393 11.3568 7.9733 11.5452C8.78105 11.4861 9.62174 11.4357 10.6958 10.3331C10.1037 11.3765 7.44724 15.9359 7.44724 15.9359C7.44724 15.9359 3.60024 16.0061 1.06049 11.999H1.06055Z",
    fill: "#61BC5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42798 15.9668L8.49754 11.5214C8.49754 11.5214 9.67278 11.4293 10.6588 10.353C10.0469 11.425 7.42798 15.9668 7.42798 15.9668V15.9668Z",
    fill: "#5AB055"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40393 8.03374C4.40393 6.07411 5.99956 4.48486 7.96706 4.48486C9.93455 4.48486 11.5302 6.07411 11.5302 8.03374C11.5302 9.99343 9.93455 11.5826 7.96706 11.5826C5.99956 11.5804 4.40393 9.99343 4.40393 8.03374V8.03374Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00012 8.03368C5.00012 6.40285 6.32725 5.07886 7.96689 5.07886C9.60427 5.07886 10.9336 6.40067 10.9336 8.03368C10.9336 9.66457 9.60652 10.9886 7.96689 10.9886C6.32944 10.9886 5.00012 9.66457 5.00012 8.03368V8.03368Z",
    fill: "url(#paint0_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1748 4.49146L10.7709 5.77818C10.7709 5.77818 10.1063 4.80707 8.67798 4.49146C9.91705 4.48486 15.1748 4.49146 15.1748 4.49146V4.49146Z",
    fill: "#EACA05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53372 8.98503C3.91522 7.9175 1.37109 3.54224 1.37109 3.54224L4.63272 6.75572C4.63272 6.75572 4.29816 7.44185 4.42366 8.42385L4.53366 8.98503H4.53372Z",
    fill: "#DF3A32"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.96674,
    y1: 5.12058,
    x2: 7.96674,
    y2: 10.8107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1072BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.2c174638b5d116dd27a0fbd760c4c5f6.svg";
export { ForwardRef as ReactComponent };